import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import useTelemetry from '@/providers/TelemetryProvider/useTelemetry';
import { mixpanelEvents } from '@/constants/mixpanel';
import { TCustomAxiosError } from '@/services/api';
import queryKeys from '@/constants/queryKeys';
import { TRosterUserPeerSupportCertificateInfo } from '@/types/Roster.types';
import { upgradeMemberToPeerSupportPost } from '@/services/api/requests/peer-support';

const useUpgradeMemberToPeerSupport = (onSuccessCallback?: () => void) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { trackEvent } = useTelemetry();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({
      organizationId,
      userId,
      peerSupportUpgradeInfo,
    }: {
      organizationId: string;
      userId: string;
      peerSupportUpgradeInfo: TRosterUserPeerSupportCertificateInfo;
    }) => {
      const response = await upgradeMemberToPeerSupportPost(organizationId, userId, peerSupportUpgradeInfo);

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.organization.members] });

      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Successfully upgraded Member to Peer Support!',
      });

      trackEvent(mixpanelEvents.UPGRADE_TO_PEER_SUPPORT);

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast({
        title: 'Error while upgrading Member to Peer Support',
      }, error);
    },
  });

  return { isPending, mutate };
};

export default useUpgradeMemberToPeerSupport;
